import axios from '@/utils/axios'

// GET ALL
export const getInstallationPersons = (params = {}) => {
  return axios.get('/installation-persons', { params })
}

// GET BY ID
export const getInstallationPersonById = (id) => {
  return axios.get(`/installation-persons/${id}`)
}

// DROPDOWN
export const getInstallationPersonDropdown = () => {
  return axios.get('/installation-persons/dropdown')
}

// CREATE
export const createInstallationPerson = (data) => {
  return axios.post('/installation-persons', data)
}

// UPDATE 
export const updateInstallationPerson = (id, data) => {
  return axios.put(`/installation-persons/${id}`, data)
}

// MARK AS MANAGER
export const markAsManager = (id) => {
  return axios.patch(`/installation-persons/${id}/mark-as-manager`)
}

// DELETE
export const deleteInstallationPerson = (id) => {
  return axios.delete(`/installation-persons/${id}`)
}